import axiosServices from 'utils/axios';
import { User } from 'types/administrativeTools/user';

// ==============================|| AUTH SERVICE ||============================== //

export interface LoginRequest {
  useLogin: string;
  usePassword: string;
}

export interface LoginResponse {
  token: string;
  refreshToken: string;
  expiration: string;
  user: User;
}

/**
 * POST /Users/Login
 * Authenticates the user and returns token + user data.
 * Throws an English-language Error on failure.
 */
export const loginUser = async (credentials: LoginRequest): Promise<LoginResponse> => {
  try {
    const res = await axiosServices.post<{ success: boolean; data: LoginResponse }>(
      '/Users/login',
      credentials
    );
    return res.data.data;
  } catch (error: any) {
    // Log real error for debugging — visible in browser devtools console
    console.error('[authService] Login error:', error);

    if (error?.status === 429) {
      throw new Error('Too many login attempts. Please wait a moment and try again.');
    }
    if (error?.status === 401 || error?.success === false) {
      throw new Error('Invalid credentials. Please check your username and password.');
    }
    throw new Error('A server error occurred. Please try again later.');
  }
};
